const map = {
	"./cst/user/AssiGneeGroup": [
		96935,
		[
			8445,
			8993,
			712,
			1247
		]
	],
	"./spoc/user/AssiGneeGroup": [
		20554,
		[
			8445,
			8993,
			712,
			7292
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52511;
module.exports = webpackAsyncContext;